
import { useCallback } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { useToast } from '@/hooks/use-toast';

export const useChatManagement = () => {
  const { toast } = useToast();

  const fetchUserProfile = useCallback(async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return { userPlan: 'FREE' as const, requestCount: 0 };

      const { data: profile } = await supabase
        .from('profiles')
        .select('plan')
        .eq('id', user.id)
        .single();

      // Ensure we only return valid values that match the expected type
      const userPlan = profile?.plan === 'UNLIMITED' ? 'UNLIMITED' as const : 'FREE' as const;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const { count } = await supabase
        .from('saved_chats')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', user.id)
        .gte('created_at', today.toISOString());

      return { userPlan, requestCount: count || 0 };
    } catch (error) {
      console.error('Error fetching user profile:', error);
      return { userPlan: 'FREE' as const, requestCount: 0 };
    }
  }, []);

  const saveChat = useCallback(async (question: string, answer: string) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { error } = await supabase.from('saved_chats').insert({
        user_id: user.id,
        title: question.substring(0, 50) + (question.length > 50 ? '...' : ''),
        content: JSON.stringify({ question, answer })
      });

      if (error) {
        console.error('Error saving chat:', error);
        toast({
          title: "Error",
          description: "No se pudo guardar el chat. Por favor, intente más tarde.",
          variant: "destructive"
        });
        return false;
      }
      
      return true;
    } catch (error) {
      console.error('Error in saveChat:', error);
      return false;
    }
  }, [toast]);

  return {
    fetchUserProfile,
    saveChat
  };
};
